export default __webpack_public_path__ + "static/unmfoundation-ceec4216c546a659cdbe1b80ffc779d9.png";